import {
	type BankTransactionFilterDto,
	getBanksTransactions,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PAYMENT_LIST = "PAYMENT_LIST";

export const paymentListQueryKey = (filter: BankTransactionFilterDto) => [
	PAYMENT_LIST,
	filter.query,
	filter.pageLimit,
	filter.pageIndex,
	filter.orderBy,
	filter.orderDirection,
	filter.marketId,
	filter.type,
	filter.importedAt,
	filter.externalId,
	filter.createdAtFrom,
	filter.createdAtTo,
	filter.isRenovation,
];

export function usePaymentsQuery(filter: BankTransactionFilterDto) {
	return useQuery({
		queryKey: paymentListQueryKey(filter),
		queryFn: processResponse(() =>
			getBanksTransactions(
				filter?.query,
				filter?.pageLimit,
				filter?.pageIndex,
				filter?.orderBy,
				filter?.orderDirection ?? undefined,
				filter?.marketId,
				filter?.type ?? undefined,
				filter?.importedAt,
				filter?.externalId,
				filter?.createdAtFrom,
				filter?.createdAtTo,
				filter?.isRenovation,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: true,
	});
}
